var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExpandTeamBannerIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 253.847,
    height: 212.621,
    viewBox: "0 0 253.847 212.621",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3390",
    "data-name": "Rectangle 3390",
    width: 253.847,
    height: 203.542,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22268",
    "data-name": "Group 22268",
    transform: "translate(-964.898 -808.223)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22239",
    "data-name": "Group 22239",
    transform: "translate(127 586.467)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11341",
    "data-name": "Path 11341",
    d: "M152.018,352.337c0,4.264-34.03,7.72-76.009,7.72S0,356.6,0,352.337s34.03-7.721,76.009-7.721,76.009,3.457,76.009,7.721",
    transform: "translate(881.023 74.32)",
    fill: "#7586ec",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22267",
    "data-name": "Group 22267",
    transform: "translate(964.898 808.219)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22266",
    "data-name": "Group 22266",
    transform: "translate(0 0.004)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11527",
    "data-name": "Path 11527",
    d: "M149.2,501.331H1.606A1.606,1.606,0,0,1,0,499.724v-2.407a1.606,1.606,0,0,1,1.606-1.606H149.2a1.606,1.606,0,0,1,1.606,1.606v2.407a1.606,1.606,0,0,1-1.606,1.606",
    transform: "translate(0 -399.688)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11528",
    "data-name": "Path 11528",
    d: "M882.625,64.021c2,7.051-2.884,14.316-8.265,15.843s-9.22-3.265-11.22-10.315.74-14,6.121-15.53,11.364,2.952,13.364,10",
    transform: "translate(-695.415 -43.315)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11529",
    "data-name": "Path 11529",
    d: "M784.779,812.2s13.79,21.418,15.653,22.349,6.518,1.164,4.772,4.656-2.444,17.228-4.074,17.926-15.6,2.328-13.5,0,3.384-1.164,4.441-5.354,2.543-12.106.564-13.736-14.085-16.3-14.085-16.3Z",
    transform: "translate(-627.737 -654.872)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11530",
    "data-name": "Path 11530",
    d: "M335.623,859.684S318.86,887.312,315.756,889.8s-13.348,6.208-4.967,6.829,12.417-2.794,17.694-4.346,11.8-2.483,9.313-6.519-1.452-12.845,3.9-18.433-6.074-7.643-6.074-7.643",
    transform: "translate(-247.986 -693.157)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11531",
    "data-name": "Path 11531",
    d: "M508.33,528.868s-41.5-1.085-57.949,12.417c-9.623,14.59-32.9,57.638-34.713,62.382,1.242,1.242,8.226,3.482,11.331,3.172,9.157-10.919,21.261-20.359,26.076-28.924,5.932-10.554,7.761-15.831,17.384-16.763s31.353-4.035,37.872-4.035,0-28.248,0-28.248",
    transform: "translate(-335.15 -426.406)",
    fill: "#262d4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11532",
    "data-name": "Path 11532",
    d: "M1006.854,779.891h-2.175l-15.6-65.077h4.785Z",
    transform: "translate(-797.488 -576.349)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11533",
    "data-name": "Path 11533",
    d: "M744.456,770.315h2.175l17.9-67.378h-4.785Z",
    transform: "translate(-600.249 -566.773)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11534",
    "data-name": "Path 11534",
    d: "M676.459,514.281l-24.126,4.164s-32.06.295-46.715,3.024c-13.333,2.483-15.3,17.633,0,38.492,8.69,11.85,16.037,21.3,31.062,31.96,3.822-2.806,5.284-3.868,6.341-10.619-1.088-1.491-3.9-10.823-4.776-12.649-8.311-17.372-19.4-23.69-19.557-25.4,1.863-3.026,49.334,15.776,58.773,4.715,9.011-10.56-1-33.689-1-33.689",
    transform: "translate(-479.638 -414.661)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11535",
    "data-name": "Path 11535",
    d: "M893.106,231.176a25.244,25.244,0,0,0-18.878,4.7c-5.289,5.391-11.273,14.281-10.906,28.946.466,18.625-2.882,19.821.61,24.942,14.565,6.015,39.475,31.856,33.609,4.152-4.247-20.06,9.316-35.012-1.626-57.264-.891-1.811-2-3.567-2.809-5.474",
    transform: "translate(-695.283 -186.174)",
    fill: "#699dee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11536",
    "data-name": "Path 11536",
    d: "M863.321,291.2c-.283,9.709-1.654,12.57-.606,15.614,5.938.606,16.8,2.982,19.513,6.782,3.1,4.346,6.209,4.967,4.76,1.759s-5.277-7.76.621-23.385,8.692-26.179,2.9-37.044Z",
    transform: "translate(-695.286 -205.542)",
    fill: "#4a75cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11537",
    "data-name": "Path 11537",
    d: "M942.663,150.449a75.786,75.786,0,0,1-4.873-19.669l-10.244,3.027s5.82,13.037.233,17.693a53.381,53.381,0,0,0-3.993,3.647,25.244,25.244,0,0,1,18.877-4.7",
    transform: "translate(-744.841 -105.448)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11538",
    "data-name": "Path 11538",
    d: "M953.817,135.528c-.607-.54-1.366-1.214-2.164-1.918l-8.355,2.469-.018.045a34.12,34.12,0,0,1,2.61,10.2c2.49-1.511,5.216-3.974,8.333-8.276-.169-.955-.3-1.806-.407-2.524",
    transform: "translate(-760.559 -107.729)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11539",
    "data-name": "Path 11539",
    d: "M725.028,246.137c-10.551,3.69-9.38,14.8-19.09,31.2-5.025,8.483-9.692,8.357-9.692,8.357a224.808,224.808,0,0,1-26.04-1.649c-8.926-1.091-9.493,1.566-3.285,3.785,12.521,4.477,25.514,9.295,35.99,8.131s28.394-27.894,29.318-34.852c1.277-9.623-1.888-16.827-7.2-14.968",
    transform: "translate(-534.407 -198.222)",
    fill: "#f09959"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11540",
    "data-name": "Path 11540",
    d: "M801.633,436.2q-.984,0-2.017-.026a100.313,100.313,0,0,1-19.154-2.358c-5.491-1.116-8.516-1.731-12.036-.049a2.712,2.712,0,1,1-2.338-4.894c5.159-2.465,9.478-1.588,15.455-.373a95.555,95.555,0,0,0,18.208,2.251c9.089.227,14.63-1.122,17.439-4.236,2.5-2.775,3.235-7.438,2.3-14.674-.318-2.476-.637-4.536-.918-6.354-.793-5.127-1.316-8.514-.668-13.75.6-4.862,2.213-11.339,5.942-23.9a2.712,2.712,0,1,1,5.2,1.544c-6.949,23.4-6.6,25.682-5.113,35.275.286,1.85.61,3.946.937,6.491,1.147,8.923-.015,14.96-3.656,19-3.75,4.158-9.836,6.052-19.584,6.052",
    transform: "translate(-616.446 -295.021)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11541",
    "data-name": "Path 11541",
    d: "M336.763,979.892c-11.123,5.44-17.109,8.557-20.675,8.26-.842-.07-1.539-.156-2.124-.247-3.967,2.344-10.3,5.115-3.174,5.643,8.382.621,12.417-2.794,17.694-4.346s11.8-2.483,9.313-6.519a8.493,8.493,0,0,1-1.033-2.79",
    transform: "translate(-247.986 -790.08)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11542",
    "data-name": "Path 11542",
    d: "M838.547,929.922c-.272,8.806-1.482,17.533-6.868,19.181a9.051,9.051,0,0,1-3.88.346c-.847,1.047-1.881,1.059-3.268,2.6-2.1,2.328,11.873.7,13.5,0s2.328-14.434,4.074-17.926c1.434-2.868-1.451-3.538-3.56-4.2",
    transform: "translate(-664.639 -749.789)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11543",
    "data-name": "Path 11543",
    d: "M458.8,349.19H423.466a2.712,2.712,0,0,1-2.459-1.569l-14.279-30.732a2.712,2.712,0,1,1,4.919-2.286l13.55,29.163h33.6a2.712,2.712,0,1,1,0,5.424",
    transform: "translate(-327.737 -252.397)",
    fill: "#699dee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11544",
    "data-name": "Path 11544",
    d: "M583.99,428.8c-7.14-.1-14.221-4.359-17.739-3.738s-15,8.588-13.555,8.9,10.555-4.409,10.865-4.481,2.276,3.269,7.14,4.5.034-3.645,15.109.908c9.8,2.96-1.82-6.084-1.82-6.084",
    transform: "translate(-445.533 -342.679)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11545",
    "data-name": "Path 11545",
    d: "M915.217,188.684l1.051,8.452s-9.239.55-13.837,3.137-11.382,10.061-11.382,10.061l5.543-9.543.8-6.105Z",
    transform: "translate(-718.445 -152.135)",
    fill: "#d2e4ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11546",
    "data-name": "Path 11546",
    d: "M771.505,241.4c-6.862-1.286-10.037,4.863-14.486,14.9s-12.045,22.227-13.555,23.8-25.455,0-25.455,0-.724,6.933,0,7.761,4.863.724,4.863.724,1.655,1.322,3.208,2.368,14.693,3.013,20.8,2.7,11.693-.828,12.52-1.759,17.487-26.593,18.522-35.8-2.913-14.037-6.415-14.693",
    transform: "translate(-578.665 -194.502)",
    fill: "#d2e4ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11547",
    "data-name": "Path 11547",
    d: "M845.016,4.683c-12.979.621-10.943,20.146-10.943,20.146s3.371,1.041,10.433-.123c-.543-2.1-.31-7.45-.31-7.45a48.8,48.8,0,0,0,1.863,6.985c1.493.684,3.182.077,6.053-.616,1.475,6.2,5.641,8.825,8.494,9.722,3.153.991,6.489,2.173,10.214.31s1.677-20.9-.3-24.73c-2.969-5.747-7.9-10.891-16.44-8.174a63.409,63.409,0,0,0-9.061,3.932",
    transform: "translate(-672.412 -0.004)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11548",
    "data-name": "Path 11548",
    d: "M1007.564,138.052l5.306,7.75s-5.881,14.693,11.223,21.351c13.4,5.213,11.817,14.4,5.764,23.638s3.621,17.306,3.621,17.306,1.475-10.234,14.49-12.165c17.746-2.634,22.771-26.459,9.516-38.372-10.968-9.858-14.305-1.694-21.729-10.541s-21.44-2.871-21.44-2.871l-5.137-7.491Z",
    transform: "translate(-812.391 -110.185)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11549",
    "data-name": "Path 11549",
    d: "M1089.727,198.689a.472.472,0,0,1-.414-.7c4.462-8.154.821-18.034-1.01-20.71-.194-.284-.378-.571-.573-.876-1.8-2.809-4.038-6.3-15.987-8.455-2.878-.518-5.208-2.228-7.674-4.039-5.1-3.741-10.87-7.98-23.418-2.2a.472.472,0,1,1-.395-.857c13.052-6.008,19.066-1.593,24.371,2.3,2.376,1.744,4.62,3.392,7.283,3.871,12.354,2.224,14.716,5.912,16.615,8.875.191.3.371.58.557.852,1.918,2.8,5.733,13.155,1.059,21.7a.473.473,0,0,1-.415.245",
    transform: "translate(-838.528 -127.315)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11550",
    "data-name": "Path 11550",
    d: "M935.217,108.024a18.665,18.665,0,0,1-2.756-.222c-4.541-.68-10.632-3.26-11.11-17.751a.472.472,0,1,1,.943-.031c.2,5.973,1.382,10.392,3.522,13.135a9.9,9.9,0,0,0,6.785,3.714c4.2.629,6.988-.146,8.278-2.306a.472.472,0,1,1,.81.484c-1.183,1.98-3.355,2.977-6.472,2.977",
    transform: "translate(-742.877 -72.215)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11551",
    "data-name": "Path 11551",
    d: "M81.678,619.16h3.487L98.73,515.468H91.058Z",
    transform: "translate(-65.856 -415.618)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11552",
    "data-name": "Path 11552",
    d: "M621.551,619.16h-3.487L604.5,515.468h7.671Z",
    transform: "translate(-487.403 -415.618)",
    fill: "#040227"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandTeamBannerIcon);
export default __webpack_public_path__ + "static/media/expand-team-banner-icon.6ba37f98d8722219deffd6a816d480e3.svg";
export { ForwardRef as ReactComponent };